import { css } from '@emotion/css';
import React from 'react';
import { FadeInImage } from './FadeInImage';

export const Photo: React.FC<{ srcSet: string }> = ({ srcSet }) => {
  return (
    <div
      className={css`
        display: inline-block;
        background: white;
        border-radius: 8px;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
        padding: 8px;
        width: 100%;
        height: 100%;
        .image {
          width: 100%;
          height: 100%;
          position: relative;
        }
        img,
        svg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          border-radius: 4px;
        }
      `}
    >
      <div className="image">
        <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h320v200H0V0z" fill="#DFD9C9" stroke="none" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M160 140c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40zm15.906-25.041c3.495-2.08 5.398-6.197 5.879-10.272.368-3.084-.226-6.331-1.917-8.927-1.627-2.477-4.308-4.295-7.237-4.656a.292.292 0 01-.227-.431 44.102 44.102 0 016.693-9.084A11.32 11.32 0 00173.6 78.3a36.986 36.986 0 01-2.964 10.866.247.247 0 01-.41.064c-.175-.2-.352-.407-.533-.619-.82-.963-1.703-2-2.7-2.586-6.856-4.025-16.455-1.995-20.785 5.016-1.943 3.144-2.529 6.832-3.115 10.521-.23 1.442-.459 2.883-.769 4.293a35.527 35.527 0 01-3.374 9.118c-.027.054-.07.123-.117.199-.113.184-.251.406-.251.551 0 .361.573.595.948.722 4.619 1.528 9.31 2.957 14.149 3.537 5.058.601 12.868.368 15.181-1.196.078-.049.036-.162-.049-.162-3.785.035-6.261-1.755-6.792-4.846-.552-3.212 1.047-6.105 3.537-7.449 2.491-1.338 5.971-1.111 8.058.799 1.818 1.655 2.596 4.641 1.5 7.202-.131.301-.427.616-.654.858-.14.149-.255.271-.287.344-.064.142.085.283.226.213l.225-.116c.395-.203 1.131-.58 1.282-.67z"
            fill="#CDC7BB"
          />
        </svg>
        <FadeInImage srcSet={srcSet} ariaHidden={true} />
      </div>
    </div>
  );
};
